import { useEffect, useState } from "react";
import { shuffle } from "lodash";
import { TIME } from "./common/utils";
import Modal from "./common/Modal";
import "./Piñata.scss";

const GIFTS = [
    "You light up the room",
    "You always know how to find the silver lining",
    "Jokes are funnier when you tell them",
    "The thing you don’t like about yourself is what makes you really interesting",
    "When you make up your mind nothing stands in your way",
    "You could survive a zombie apocalypse",
    "You should be thanked more often: ThankYou",
    "You’re one of a kind",
    "You’re better than a unicorn because you’re real"
  ],
  THEMES = [
    "#FF8D8D",
    "#DEBDFF",
    "#CEFFF2",
    "#B1D8F7",
    "#F0FFCB",
    "#FF98BE",
    "#E6E6FD",
    "#CDF4FC",
    "#ECFCFF"
  ],
  IMAGES = [
    "https://cdn.mindpeers.co/emotions/lonely/images/burger.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/cake.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/chocolate.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/donut.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/french.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/lolipop.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/noodles-bowl.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/pizza.svg",
    "https://cdn.mindpeers.co/emotions/lonely/images/tropical.svg"
  ],
  GIFTS_COUNT = GIFTS.length,
  GIFTBOX = "https://cdn.mindpeers.co/emotions/lonely/images/gift_box.svg",
  SECONDS = 4,
  GIFT_CARDS = [
    {
      id: "Rectangle_974",
      name: "Rectangle 974",
      d: "M28.137,6.578,2.394,77.305a6.994,6.994,0,0,0,4.184,8.972l26.366,9.6a6.994,6.994,0,0,0,8.972-4.184L67.659,20.963a6.994,6.994,0,0,0-4.184-8.972l-26.366-9.6a6.994,6.994,0,0,0-8.972,4.184Z",
      transform: "translate(698.703 753.472)",
      fill: "#d9d9ff"
    },
    {
      id: "Rectangle_975",
      name: "Rectangle 975",
      d: "M28.137,6.578,2.394,77.305a6.994,6.994,0,0,0,4.184,8.972l26.366,9.6a6.994,6.994,0,0,0,8.972-4.184L67.659,20.963a6.994,6.994,0,0,0-4.184-8.972l-26.366-9.6a6.994,6.994,0,0,0-8.972,4.184Z",
      transform: "translate(663.677 769.472)",
      fill: "#d9d9ff"
    },
    {
      id: "Rectangle_972",
      name: "Rectangle 972",
      d: "M71.245,3.5,6.062,41.133A6.994,6.994,0,0,0,3.5,50.7l14.029,24.3a6.994,6.994,0,0,0,9.562,2.562L92.274,39.924a6.994,6.994,0,0,0,2.562-9.562L80.807,6.062A6.994,6.994,0,0,0,71.245,3.5Z",
      transform: "translate(659.9 762.078)",
      fill: "#ecfcff"
    },
    {
      id: "Rectangle_976",
      name: "Rectangle 976",
      d: "M41.133,6.062,3.5,71.245a6.994,6.994,0,0,0,2.562,9.562l24.3,14.029a6.994,6.994,0,0,0,9.562-2.562L77.557,27.091a6.994,6.994,0,0,0-2.562-9.562L50.7,3.5a6.994,6.994,0,0,0-9.562,2.562Z",
      transform: "translate(715.303 753.438)",
      fill: "#ecfcff"
    },
    {
      id: "Rectangle_973",
      name: "Rectangle 973",
      d: "M28.137,6.578,2.394,77.305a6.994,6.994,0,0,0,4.184,8.972l26.366,9.6a6.994,6.994,0,0,0,8.972-4.184L67.659,20.963a6.994,6.994,0,0,0-4.184-8.972l-26.366-9.6a6.994,6.994,0,0,0-8.972,4.184Z",
      transform: "translate(723.21 753.472)",
      fill: "#bee2ff"
    }
  ],
  GIFT_CARDS_COUNT = GIFT_CARDS.length;

const GiftBox = ({ count, click }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={192.216}
      height={225.082}
      viewBox="0 0 192.216 225.082"
      className="game-piñata-gift"
      onClick={() => {
        let animation = document
          .querySelector("g#topi")
          .animate(
            [
              { transform: "translate(0px, 0px) rotate(0deg)" },
              { transform: "translate(-38px, 16px) rotate(-30deg)" },
              { transform: "translate(0px, 0px) rotate(0deg)" }
            ],
            {
              duration: 900,
              iterations: 1
            }
          );
        animation.onfinish = () => click();
      }}
    >
      <g
        id="gift-box_with_gifts"
        data-name="gift-box with gifts"
        transform="translate(31.732 61.834)"
      >
        <g
          id="Group_14179"
          data-name="Group 14179"
          transform="translate(-635.876 -723.166)"
        >
          {GIFT_CARDS.slice(
            count >= GIFT_CARDS_COUNT ? count - GIFT_CARDS_COUNT + 1 : 0
          ).map((item, itemIndex) => (
            <path
              key={`item${itemIndex}`}
              id={item.id}
              data-name={item.name}
              d={item.d}
              transform={item.transform}
              fill={item.fill}
            />
          ))}
        </g>
        <path
          id="Path_11894"
          data-name="Path 11894"
          d="M153.526,27v82.055A11.722,11.722,0,0,1,141.8,120.777H18.722A11.722,11.722,0,0,1,7,109.055V27Z"
          transform="translate(3.861 42.472)"
          fill="#62acb2"
        />
        <path
          id="Path_11895"
          data-name="Path 11895"
          d="M62.68,95.68H18.722A11.722,11.722,0,0,1,7,83.958V40A55.68,55.68,0,0,0,62.68,95.68Z"
          transform="translate(3.861 67.568)"
          fill="#389ba3"
        />
        <rect
          id="Rectangle_901"
          data-name="Rectangle 901"
          width={17.131}
          height={93.267}
          transform="translate(60.833 69.716)"
          fill="#389ba3"
        />
        <rect
          id="Rectangle_902"
          data-name="Rectangle 902"
          width={146.562}
          height={17.131}
          transform="translate(10.71 69.716)"
          fill="#2a747a"
        />
        <rect
          id="Rectangle_903"
          data-name="Rectangle 903"
          width={29.185}
          height={93.267}
          transform="translate(69.716 69.716)"
          fill="#f7b68b"
        />
        <rect
          id="Rectangle_904"
          data-name="Rectangle 904"
          width={29.185}
          height={14.593}
          transform="translate(69.716 69.716)"
          fill="#d2824c"
        />
        <g id="topi">
          <path
            id="Path_11889"
            data-name="Path 11889"
            d="M68.417,21.558A32.1,32.1,0,0,0,40.313,5H14.641A9.606,9.606,0,0,0,5,14.641,25.513,25.513,0,0,0,28.444,40.061V43.1h55.68V22.583Z"
            fill="#ed675b"
          />
          <path
            id="Path_11890"
            data-name="Path 11890"
            d="M39.377,21.723a3,3,0,0,1-.715-.088L15.218,15.774a2.93,2.93,0,1,1,1.424-5.685l23.444,5.861a2.931,2.931,0,0,1-.709,5.773Z"
            transform="translate(15.442 9.652)"
            fill="#c63f38"
          />
          <path
            id="Path_11891"
            data-name="Path 11891"
            d="M47.708,21.558A32.1,32.1,0,0,1,75.811,5h25.671a9.606,9.606,0,0,1,9.641,9.641A25.513,25.513,0,0,1,87.68,40.061V43.1H32V22.583Z"
            transform="translate(52.124)"
            fill="#ed675b"
          />
          <path
            id="Path_11892"
            data-name="Path 11892"
            d="M43.929,21.723a3,3,0,0,0,.715-.088l23.444-5.861a2.93,2.93,0,1,0-1.424-5.685L43.219,15.949a2.931,2.931,0,0,0,.709,5.773Z"
            transform="translate(69.501 9.652)"
            fill="#c63f38"
          />
          <path
            id="Path_11893"
            data-name="Path 11893"
            d="M47.444,13.915V31.5H34.96A10.981,10.981,0,0,1,24,20.538V19.014A10.975,10.975,0,0,1,29.539,9.49a32.017,32.017,0,0,1,2.2,3.4Z"
            transform="translate(36.68 8.668)"
            fill="#a0372e"
          />
          <rect
            id="Rectangle_900"
            data-name="Rectangle 900"
            width={34.896}
            height={23.475}
            rx={3.742}
            transform="translate(66.543 16.42)"
            fill="#c63f38"
          />
          <g id="Group_14173" data-name="Group 14173">
            <rect
              id="Rectangle_905"
              data-name="Rectangle 905"
              width={157.982}
              height={35.53}
              rx={2}
              transform="translate(5 39.896)"
              fill="#389ba3"
            />
            <path
              id="Path_11896"
              data-name="Path 11896"
              d="M91.819,22.861V46.305a5.832,5.832,0,0,1-2.52,4.806A49.86,49.86,0,0,0,42,17H85.958a5.879,5.879,0,0,1,5.861,5.861Z"
              transform="translate(71.429 23.166)"
              fill="#62acb2"
            />
            <rect
              id="Rectangle_906"
              data-name="Rectangle 906"
              width={14.593}
              height={35.53}
              transform="translate(55.123 39.896)"
              fill="#2a747a"
            />
            <rect
              id="Rectangle_907"
              data-name="Rectangle 907"
              width={41.24}
              height={35.53}
              transform="translate(63.371 39.896)"
              fill="#f49f69"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const Piñata = ({ feature, onDone }) => {
  const [modal, setModal] = useState(true),
    [modalType, setModalType] = useState("START"),
    [seconds, setSeconds] = useState(SECONDS),
    [hit, setHit] = useState(false),
    [gifts, setGifts] = useState([]),
    [count, setCount] = useState(0),
    [end, setEnd] = useState(false),
    handleClick = () => {
      if (count + 1 < GIFTS_COUNT) setCount(count + 1);
      if (count + 1 === GIFTS_COUNT) {
        setCount(count + 1);
        setEnd(true);
      }
    };
  useEffect(() => {
    const RANDOM = {
      gifts: shuffle(GIFTS),
      themes: shuffle(THEMES),
      images: shuffle(IMAGES)
    };
    setGifts(
      Array.from({ length: GIFTS_COUNT }).map((val, index) => ({
        text: RANDOM.gifts[index],
        theme: RANDOM.themes[index],
        image: RANDOM.images[index]
      }))
    );
    setEnd(false);
    setModal(true);
    setModalType("START");
    setSeconds(SECONDS);
    setHit(false);
    setCount(0);
  }, []);
  useEffect(() => {
    if (hit) {
      let cancel = false;
      let timeout = TIME(seconds, setSeconds, cancel, true, () => {
        setEnd(true);
      });
      return () => {
        clearTimeout(timeout);
        cancel = true;
      };
    }
  }, [hit, seconds]);
  return (
    <>
      <Modal
        feature={feature}
        show={modal}
        type={modalType}
        kind={"PIÑATA"}
        intro={`Hit the piñata and collect the gifts.`}
        done={() => {
          if (modalType === "START") {
            setModal(false);
            setModalType("");
          }
        }}
      />
      {!end && (
        <div className="game-piñata">
          <div className="game-piñata-header">
            <div className="game-piñata-header-empty" />
            <div className="game-piñata-header-title">
              Click on the gift box to collect
            </div>
            {hit && (
              <div className="game-piñata-header-timer">
                <div className="emotion-text game-piñata-header-timer-info">{`${seconds} sec remaining`}</div>
              </div>
            )}
          </div>
          {!hit && (
            <img
              className="game-piñata-gift"
              onClick={() => {
                setHit(true);
                setCount(count + 1);
              }}
              src={GIFTBOX}
              alt="Closed Gift box"
            />
          )}
          {hit && (
            <>
              <div className="game-piñata-card-wrapper">
                {count > 0 && gifts[count - 1] && (
                  <div
                    className="game-piñata-card"
                    style={{ backgroundColor: gifts[count - 1].theme }}
                  >
                    <img src={gifts[count - 1].image} alt="Gift" />
                  </div>
                )}
              </div>
              <GiftBox count={count} click={handleClick} />
            </>
          )}
        </div>
      )}
      {end && (
        <div className="game-piñata-end">
          <div className="game-piñata-end-title">
            Here are your collected gifts
          </div>
          <div className="game-piñata-end-gifts">
            {gifts.slice(0, count).map((gift, giftIndex) => (
              <div
                key={`gift${giftIndex}`}
                className="game-piñata-end-gift"
                style={{ backgroundColor: gift.theme }}
              >
                {gift.text}
              </div>
            ))}
          </div>
          <div className="game-piñata-end-footer">
            <button className="emotion-basic-button" onClick={() => onDone()}>
              NEXT
            </button>
            <button
              className="emotion-basic-button"
              onClick={() => {
                const RANDOM = {
                  gifts: shuffle(GIFTS),
                  themes: shuffle(THEMES),
                  images: shuffle(IMAGES)
                };
                setGifts(
                  Array.from({ length: GIFTS_COUNT }).map((val, index) => ({
                    text: RANDOM.gifts[index],
                    theme: RANDOM.themes[index],
                    image: RANDOM.images[index]
                  }))
                );
                setEnd(false);
                setModal(true);
                setModalType("START");
                setSeconds(SECONDS);
                setHit(false);
                setCount(0);
              }}
            >
              Play Again
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Piñata;
